import { render, staticRenderFns } from "./mediaPlatformShare.vue?vue&type=template&id=630d9352&scoped=true&"
import script from "./mediaPlatformShare.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformShare.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformShare.vue?vue&type=style&index=0&id=630d9352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d9352",
  null
  
)

component.options.__file = "mediaPlatformShare.vue"
export default component.exports